// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SoftwarePlus -- tokens do design system, layout "Razão" (canvas de design aprovado em 20/10/2026).
   Fonte da verdade das cores/espacamento/radius/sombras: nunca hard-code hex fora daqui.
   Mantem os NOMES de variavel antigos (sp-*, color, font, space, radius, shadow) pra nao precisar
   reescrever todo componente -- so os VALORES mudaram: ground cinza-esverdeado, barra lateral em
   tinta escura, uma cor de ação (verde conta), cores de status reservadas, números em mono. */

:root {
  /* ---- Razão: base ---- */
  --sp-ground: #f1f2ee;
  --sp-surface: #ffffff;
  --sp-sunk: #f7f8f5;
  --sp-ink: #15201b;
  --sp-ink-2: #46514b;
  --sp-ink-3: #5f6963;
  --sp-rule: #d8ddd7;
  --sp-rule-2: #e8ebe6;

  /* barra lateral */
  --sp-side: #15201b;
  --sp-side-2: #1f2b25;
  --sp-side-line: #28352e;
  --sp-side-ink: #b4beb8;
  --sp-side-muted: #808c85;

  /* ação e status */
  --sp-accent: #0e6b55;
  --sp-accent-hover: #0a5242;
  --sp-accent-soft: #e1eee8;
  --sp-ok: #16856a;
  --sp-warn: #c2721f;
  --sp-warn-ink: #8a4a06;
  --sp-bad: #a3241b;
  --sp-bad-hover: #861c15;
  --sp-bad-soft: #fcf6f5;
  --sp-info: #3f6fa8;
  --sp-mute: #9aa39e;

  --sp-font-sans: "IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  --sp-font-mono: "IBM Plex Mono", ui-monospace, Menlo, Consolas, monospace;

  /* ---- nomes antigos (usados inline nas telas), valores novos ---- */
  --sp-black: var(--sp-ink);
  --sp-black-hover: var(--sp-ink-2);
  --sp-navbar: var(--sp-side);
  --sp-sidebar: var(--sp-side);
  --sp-grey-600: var(--sp-ink-3);
  --sp-grey-500: var(--sp-ink-3);
  --sp-grey-400: var(--sp-mute);
  --sp-grey-300: var(--sp-rule);
  --sp-grey-200: var(--sp-rule-2);
  --sp-grey-100: var(--sp-rule-2);
  --sp-grey-050: var(--sp-sunk);
  --sp-off-white: var(--sp-sunk);
  --sp-white: #ffffff;
  --sp-page: var(--sp-ground);
  --sp-shell: var(--sp-ground);

  /* cores que a sidebar antiga usava em ícones de linha (lápis etc.) */
  --sp-rail-1: var(--sp-ink-2);

  --sp-primary: var(--sp-accent);
  --sp-success: var(--sp-ok);
  --sp-danger: var(--sp-bad);
  --sp-warning: var(--sp-warn);
  --sp-secondary: var(--sp-ink-3);

  --sp-text-strong: var(--sp-ink);
  --sp-text-body: var(--sp-ink);
  --sp-text-muted: var(--sp-ink-3);
  --sp-text-label: var(--sp-ink-2);

  --sp-shadow-card: none;
  --sp-shadow-panel: none;

  --color-bg: var(--sp-ground);
  --color-page: var(--sp-ground);
  --color-surface: var(--sp-surface);
  --color-text: var(--sp-ink);
  --color-accent: var(--sp-accent);
  --color-accent-hover: var(--sp-accent-hover);
  --color-accent-2: var(--sp-accent);
  --color-divider: var(--sp-rule-2);

  --color-neutral-100: var(--sp-sunk);
  --color-neutral-200: var(--sp-rule-2);
  --color-neutral-300: var(--sp-rule);
  --color-neutral-400: var(--sp-mute);
  --color-neutral-500: var(--sp-ink-3);
  --color-neutral-600: var(--sp-ink-3);
  --color-neutral-700: var(--sp-ink-2);
  --color-neutral-800: var(--sp-side-2);
  --color-neutral-900: var(--sp-ink);

  --font-heading: var(--sp-font-sans);
  --font-heading-weight: 600;
  --font-body: var(--sp-font-sans);
  --font-mono: var(--sp-font-mono);
  --sp-font-system: var(--sp-font-sans);

  --space-1: 4px;
  --space-2: 8px;
  --space-3: 16px;
  --space-4: 24px;
  --space-6: 32px;
  --space-8: 48px;

  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 10px;
  --radius-pill: 20px;

  --shadow-sm: none;
  --shadow-md: 0 12px 32px rgba(10, 18, 14, 0.18);
  --shadow-lg: 0 30px 70px rgba(10, 18, 14, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/assets/nocturne-tokens.css"],"names":[],"mappings":"AAAA;;;;8FAI8F;;AAE9F;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;;EAEpB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;;EAExB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;;EAElB,yFAAyF;EACzF,yEAAyE;;EAEzE,qEAAqE;EACrE,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;;EAE5B,qEAAqE;EACrE,4BAA4B;;EAE5B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;;EAE/B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;;EAEhC,sBAAsB;EACtB,uBAAuB;;EAEvB,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,gCAAgC;EAChC,4CAA4C;EAC5C,kCAAkC;EAClC,iCAAiC;;EAEjC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;;EAElC,mCAAmC;EACnC,0BAA0B;EAC1B,gCAAgC;EAChC,gCAAgC;EAChC,qCAAqC;;EAErC,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB,iBAAiB;EACjB,+CAA+C;EAC/C,+CAA+C;AACjD","sourcesContent":["/* SoftwarePlus -- tokens do design system, layout \"Razão\" (canvas de design aprovado em 20/10/2026).\n   Fonte da verdade das cores/espacamento/radius/sombras: nunca hard-code hex fora daqui.\n   Mantem os NOMES de variavel antigos (sp-*, color, font, space, radius, shadow) pra nao precisar\n   reescrever todo componente -- so os VALORES mudaram: ground cinza-esverdeado, barra lateral em\n   tinta escura, uma cor de ação (verde conta), cores de status reservadas, números em mono. */\n\n:root {\n  /* ---- Razão: base ---- */\n  --sp-ground: #f1f2ee;\n  --sp-surface: #ffffff;\n  --sp-sunk: #f7f8f5;\n  --sp-ink: #15201b;\n  --sp-ink-2: #46514b;\n  --sp-ink-3: #5f6963;\n  --sp-rule: #d8ddd7;\n  --sp-rule-2: #e8ebe6;\n\n  /* barra lateral */\n  --sp-side: #15201b;\n  --sp-side-2: #1f2b25;\n  --sp-side-line: #28352e;\n  --sp-side-ink: #b4beb8;\n  --sp-side-muted: #808c85;\n\n  /* ação e status */\n  --sp-accent: #0e6b55;\n  --sp-accent-hover: #0a5242;\n  --sp-accent-soft: #e1eee8;\n  --sp-ok: #16856a;\n  --sp-warn: #c2721f;\n  --sp-warn-ink: #8a4a06;\n  --sp-bad: #a3241b;\n  --sp-bad-hover: #861c15;\n  --sp-bad-soft: #fcf6f5;\n  --sp-info: #3f6fa8;\n  --sp-mute: #9aa39e;\n\n  --sp-font-sans: \"IBM Plex Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --sp-font-mono: \"IBM Plex Mono\", ui-monospace, Menlo, Consolas, monospace;\n\n  /* ---- nomes antigos (usados inline nas telas), valores novos ---- */\n  --sp-black: var(--sp-ink);\n  --sp-black-hover: var(--sp-ink-2);\n  --sp-navbar: var(--sp-side);\n  --sp-sidebar: var(--sp-side);\n  --sp-grey-600: var(--sp-ink-3);\n  --sp-grey-500: var(--sp-ink-3);\n  --sp-grey-400: var(--sp-mute);\n  --sp-grey-300: var(--sp-rule);\n  --sp-grey-200: var(--sp-rule-2);\n  --sp-grey-100: var(--sp-rule-2);\n  --sp-grey-050: var(--sp-sunk);\n  --sp-off-white: var(--sp-sunk);\n  --sp-white: #ffffff;\n  --sp-page: var(--sp-ground);\n  --sp-shell: var(--sp-ground);\n\n  /* cores que a sidebar antiga usava em ícones de linha (lápis etc.) */\n  --sp-rail-1: var(--sp-ink-2);\n\n  --sp-primary: var(--sp-accent);\n  --sp-success: var(--sp-ok);\n  --sp-danger: var(--sp-bad);\n  --sp-warning: var(--sp-warn);\n  --sp-secondary: var(--sp-ink-3);\n\n  --sp-text-strong: var(--sp-ink);\n  --sp-text-body: var(--sp-ink);\n  --sp-text-muted: var(--sp-ink-3);\n  --sp-text-label: var(--sp-ink-2);\n\n  --sp-shadow-card: none;\n  --sp-shadow-panel: none;\n\n  --color-bg: var(--sp-ground);\n  --color-page: var(--sp-ground);\n  --color-surface: var(--sp-surface);\n  --color-text: var(--sp-ink);\n  --color-accent: var(--sp-accent);\n  --color-accent-hover: var(--sp-accent-hover);\n  --color-accent-2: var(--sp-accent);\n  --color-divider: var(--sp-rule-2);\n\n  --color-neutral-100: var(--sp-sunk);\n  --color-neutral-200: var(--sp-rule-2);\n  --color-neutral-300: var(--sp-rule);\n  --color-neutral-400: var(--sp-mute);\n  --color-neutral-500: var(--sp-ink-3);\n  --color-neutral-600: var(--sp-ink-3);\n  --color-neutral-700: var(--sp-ink-2);\n  --color-neutral-800: var(--sp-side-2);\n  --color-neutral-900: var(--sp-ink);\n\n  --font-heading: var(--sp-font-sans);\n  --font-heading-weight: 600;\n  --font-body: var(--sp-font-sans);\n  --font-mono: var(--sp-font-mono);\n  --sp-font-system: var(--sp-font-sans);\n\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 16px;\n  --space-4: 24px;\n  --space-6: 32px;\n  --space-8: 48px;\n\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 10px;\n  --radius-pill: 20px;\n\n  --shadow-sm: none;\n  --shadow-md: 0 12px 32px rgba(10, 18, 14, 0.18);\n  --shadow-lg: 0 30px 70px rgba(10, 18, 14, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
